import React from 'react'
import { connect } from 'react-redux'
import UserActions from '../../Redux/UserRedux'

class CreateAdmin extends React.Component {
  constructor (props) {
    super (props)
    this.roles = [
      { value: 'admin', label: 'Admin' },
      { value: 'finance', label: 'Finance' },
      { value: 'cs', label: 'CS' },
    ]
    this.state = {
      form: {
        first_name: '',
        last_name: '',
        role: this.roles[0].value,
        email: '',
        password: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value.replace(/[^\x20-\x7E]/g, '')
    if (event.target.type === 'number') {
      val = parseInt(val, 10)
    }
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    const data = this.state.form
    this.props.createUser(data)
    this.props.closeModal()
  }

  render () {
    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Create Admin</h4>
        </div>

        <form onSubmit={(event) => this._submit(event)}>
          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">First Name</label>
            </div>
            <div className="col-9">
              <input type="text" required placeholder="First Name" className="form-control" value={this.state.form.first_name} onChange={(event) => this._inputChange(event, 'first_name')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Last Name</label>
            </div>
            <div className="col-9">
              <input type="text" required placeholder="Last Name" className="form-control" value={this.state.form.last_name} onChange={(event) => this._inputChange(event, 'last_name')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Role</label>
            </div>
            <div className="col-9">
              <select value={this.state.form.role} className="form-control" onChange={(event) => this._inputChange(event, 'role')}>
                { this.roles.map((item, i) => (
                  <option value={item.value} key={i}>{ item.label }</option>
                )) }
              </select>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Email</label>
            </div>
            <div className="col-9">
              <input type="email" required placeholder="Email" className="form-control" value={this.state.form.email} onChange={(event) => this._inputChange(event, 'email')}/>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3">
              <label className="control-label">Password</label>
            </div>
            <div className="col-9">
              <input type="password" required placeholder="password" className="form-control" value={this.state.form.password} onChange={(event) => this._inputChange(event, 'password')}/>
            </div>
          </div>

          <div className="form-group d-flex justify-content-end">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
            <button
              className="btn btn-lg btn-primary"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  createUser: (data) => dispatch(UserActions.userCreateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateAdmin)


// WEBPACK FOOTER //
// ./src/Containers/ManageAdmin/CreateAdmin.js